import React from 'react'
import SectionWrapper from 'ui-shared/LayoutComponents/SectionWrapper'
import WithDeleteModalToolbar from 'ui-shared/CustomToolbars/WithDeleteModalToolbar'
import BaseProductForm from 'ui-shared/Forms/BaseProductForm'
import { Edit } from 'react-admin'

const RentEdit: React.FC = () => {
  return (
    <SectionWrapper>
      <Edit>
        <BaseProductForm toolbar={<WithDeleteModalToolbar />} />
      </Edit>
    </SectionWrapper>
  )
}

export default RentEdit
